import { render, staticRenderFns } from "./Opcion_Resumen.vue?vue&type=template&id=2effad68&scoped=true&"
import script from "./Opcion_Resumen.vue?vue&type=script&lang=js&"
export * from "./Opcion_Resumen.vue?vue&type=script&lang=js&"
import style0 from "./Opcion_Resumen.vue?vue&type=style&index=0&id=2effad68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../cliente-cocina/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2effad68",
  null
  
)

export default component.exports